/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyertaglinecount3Inputs */

const en_checkinflyertaglinecount3 = /** @type {(inputs: Checkinflyertaglinecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan me and check in – your friends see that you are here.`)
};

const de_checkinflyertaglinecount3 = /** @type {(inputs: Checkinflyertaglinecount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan mich und check ein – deine Freunde sehen, dass du da bist.`)
};

/**
* | output |
* | --- |
* | "Scan me and check in – your friends see that you are here." |
*
* @param {Checkinflyertaglinecount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyertaglinecount3 = /** @type {((inputs?: Checkinflyertaglinecount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyertaglinecount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyertaglinecount3(inputs)
	return de_checkinflyertaglinecount3(inputs)
});
export { checkinflyertaglinecount3 as "checkinFlyerTaglineCount" }